import { Button, Table,Spin, Form, Select} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {FileExcelOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import * as XLSX from 'xlsx';
import {AUTH_URL} from '../constants';
import { TfiReload } from 'react-icons/tfi';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import dayjs, { Dayjs } from 'dayjs';
import {ITransaction } from '../factory/interfaces';
import { IoMdArrowDropright } from 'react-icons/io';
import { notify, toastStyle } from '../pages/LoginPage';
import { useSelector } from 'react-redux';
import { IBranch } from './UsersTable';
import { selectUserDetails } from '../features/auth/authSlice';



const { RangePicker } = DatePicker

const TransactionsTable = () => {
    const dispatch = useDispatch()

    const onChange = (date: Dayjs | null) => {
      if (date) {
        setSelectedDate(date)
      }
    }
    const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs());
  
    const [transactions, setTransactions] = useState<ITransaction[]>()
    const [summary, setSummary] = useState<{ totalCredit: number; totalDebit: number, balance: Number }>()
    const [selectedBranch, setSelectedBranch] = useState<string>()
    const [branches, setBranches]= useState<IBranch[]>()


    //Functions

 const columns = [
    {
      title: 'No.',
      dataIndex: 'count',
      render: (text: any, record: any, index: any) => {
          if ( transactions && (index === transactions?.length)) {
              return <strong>Total</strong>;
          }
          return index + 1;
      },
      className: 'count-column',
        },
  {
    title: 'Date',
    dataIndex: 'date_of_creation',
    key: 'date_of_creation',
  },
    {
    title: 'Agent',
    dataIndex: 'agent',
    key: 'agent',
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: 'client',
  },
  {
    title: 'Narration',
    dataIndex: 'narration',
    key: 'narration',
  },
  {
    title: 'Debit',
    dataIndex: 'debit',
    key: 'debit',
  },
  {
    title: 'Credit',
    dataIndex: 'credit',
    key: 'credit',
   
  },
   {
    title: 'Balance',
    dataIndex: 'correct_current_balance',
    key: 'correct_current_balance',
  },

];

    //Components

   const exportToExcel = () => {
      const fileName = 'gitore_chashbook.xlsx';
      const table = document.getElementById('dlms-transactions-table');
      const clonedTable = table?.cloneNode(true) as HTMLTableElement;
      const excludedColumnIndices = [8];
      clonedTable.querySelectorAll('tr').forEach(row => {
        excludedColumnIndices.forEach(index => {
          row.deleteCell(index);
        });
      });

      const worksheet = XLSX.utils.table_to_sheet(clonedTable);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, fileName);
    }

    const getTransactions = async(date: Dayjs)=>{

      try {
      const formattedDate = date.format('YYYY-MM-DD')
      const response = await axios.post(`${AUTH_URL}/dynamic-transactions`,
      {selectedDate: formattedDate, branch: selectedBranch}, {withCredentials: true})

      if(response.data.success){
        setTransactions(response.data.transactions)
        setSummary(response.data.summary)
      }else{
        notify(response.data.message, toastStyle)
        setTransactions([])
      }
        
      } catch (error:any) {
        notify(error.message, toastStyle)
      }


    }

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().endOf('day');
  }

  const metadata = useSelector((state: any) => state.metadata)
  const userDetails = useSelector(selectUserDetails)
  const isAdmin = userDetails?.role === 'admin'

  useEffect(()=>{
    getTransactions(selectedDate)

  }, [dispatch, selectedDate, selectedBranch])

      useEffect(() => {
    if (metadata?.data?.success) {
      setBranches(metadata.data.meta_data.branches)
    }
  }, [metadata])

  return (
    <>


    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Cashbook</h4>

        </Col>
    
         <Col className='text-end py-2 d-flex justify-content-end'>
            <DatePicker 
              placeholder={selectedDate.format('YYYY-MM-DD')} 
              className='rounded-0 mx-1' 
              onChange={onChange} 
              disabledDate={disabledDate}
              />
            {
              isAdmin &&
              <Select
              allowClear
              placeholder="Select branch name"
              style={{ width: '' }}
              options={branches?.map((branch) => ({
                value: branch._id,
                label: branch.name,
              }))}
              onChange={(value: string) =>
                  setSelectedBranch(value)
                }
              />
              }

         </Col>
            
        </Row>
    
     {
      transactions ?
      <Table pagination={false} className='rounded-0 transactions-table' id='dlms-transactions-table' bordered 
        dataSource={[
          ...transactions,
          {
              count: transactions.length,
              credit: summary?.totalCredit,
              debit: summary?.totalDebit,
              correct_current_balance: summary?.balance,
              isTotalRow: true,
          },
      ]}
        columns={columns} 
        rowClassName={(record: any, index: number) =>
            record.isTotalRow ? 'total-row' : ''
        }
       />
       :
       <Spin style={{paddingTop: 100}} tip="Balancing transactions..." size="large">
        <div className="content" />
      </Spin>

     }
    </>
  )
}

export default TransactionsTable